<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ایجاد تخفیف وفاداری</h1>
          <b-row>
            <b-col cols="12" md="6">
              <price-category-picker
                @getPriceCategory="setPriceCategory"
              ></price-category-picker>
            </b-col>

            <b-col cols="12" md="6">
              <!-- <b-form-group
                label="عنوان تخفیف (جهت نمایش به ادمین)"
                label-for="title"
              >
                <b-form-input
                  v-model="loyaltyDiscountDetails.title"
                  id="title"
                  trim
                  placeholder="برای مثال تخفیف 6 هفته"
                />
              </b-form-group> -->
              <badge-picker @getBadge="setBadge"></badge-picker>
            </b-col>
            <!-- <b-col cols="12" md="6">
              <b-form-group
                label="تعداد هفته مورد نیاز برای اعمال تخفیف"
                label-for="week"
              >
                <b-input-group size="lg" append="هفته">
                  <b-form-input
                    v-model="loyaltyDiscountDetails.week"
                    id="week"
                    trim
                    type="number"
                    placeholder="6"
                  />
                </b-input-group>
              </b-form-group>
            </b-col> -->
            <b-col cols="12" md="6">
              <b-form-group
                label="حداقل تعداد روز مورد نیاز برای رزرو در هفته"
                label-for="minReserveDayPerEachWeek"
              >
                <b-input-group size="lg" append="روز">
                  <b-form-input
                    v-model="loyaltyDiscountDetails.minReserveDayPerEachWeek"
                    id="minReserveDayPerEachWeek"
                    trim
                    type="number"
                    placeholder="6"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="حداقل تعداد دقیقه مورد نیاز برای رزرو در هر روز"
                label-for="minReserveMinutePerEachDay"
              >
                <b-input-group size="lg" append="دقیقه">
                  <b-form-input
                    v-model="loyaltyDiscountDetails.minReserveMinutePerEachDay"
                    id="minReserveMinutePerEachDay"
                    trim
                    type="number"
                    placeholder="40"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-checkbox switch v-model="loyaltyDiscountDetails.isActive">
                تخفیف فعال باشد؟ ({{
                  loyaltyDiscountDetails.isActive ? "بله" : "خیر"
                }})
              </b-form-checkbox>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-checkbox
                switch
                v-model="loyaltyDiscountDetails.isabsenceEffective"
              >
                آیا تعداد هفته مورد نیاز برای اعمال تخفیف محاسبه شود؟ ({{
                  loyaltyDiscountDetails.isabsenceEffective ? "بله" : "خیر"
                }})
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-end"
            >
              <b-button
                @click="createNewLoyaltyDiscount"
                variant="success"
                :disabled="isSubmitButtonDisabled"
              >
                ثبت
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      loyaltyDiscountDetails: {
        id: 0,
        titleId: null,
        isActive: true,
        minReserveMinutePerEachDay: null,
        minReserveDayPerEachWeek: null,
        priceCategoryId: null,
        isabsenceEffective: true,
        order: null,
      },
    };
  },
  methods: {
    setBadge(badgeId) {
      this.loyaltyDiscountDetails.titleId = badgeId;
    },
    setPriceCategory(priceCategoryId) {
      this.loyaltyDiscountDetails.priceCategoryId = priceCategoryId;
    },
    async createNewLoyaltyDiscount() {
      try {
        this.isLoading = true;
        let _this = this;
        let createScheduleLoyaltyDiscount = new CreateScheduleLoyaltyDiscount(
          _this
        );
        createScheduleLoyaltyDiscount.setRequestParamDataObj(
          _this.loyaltyDiscountDetails
        );
        await createScheduleLoyaltyDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تخفیف با موفقیت ایجاد شد.",
              },
            });
            _this.loyaltyDiscountDetails = {
              id: 0,
              titleId: null,
              isActive: true,
              minReserveMinutePerEachDay: null,
              minReserveDayPerEachWeek: null,
              priceCategoryId: null,
              isabsenceEffective: false,
              order: null,
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    isSubmitButtonDisabled() {
      if (!this.loyaltyDiscountDetails.titleId) {
        return true;
      }
      return false;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
    PriceCategoryPicker,
    BadgePicker,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
import { CreateScheduleLoyaltyDiscount } from "@/libs/Api/ScheduleLoyaltyDiscount";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PriceCategoryPicker from "@/views/apps/PriceCategory/PriceCategoryPicker.vue";
import BadgePicker from "./Badges/BadgePicker.vue";
</script>
